import type { Validator } from 'last-validator'

import { isRequired } from 'last-validator'

export const isRichtextRequired = (message?: string): Validator => {
    return (options) => {
        const tempElement = document.createElement('div')
        tempElement.innerHTML = options.value || ''
        const value = tempElement.textContent

        isRequired(message)({ ...options, value })
    }
}
